import './Subscription.css';
import {useEffect, useState} from 'react';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import { getUserCompany, getUserProfile, pauseCompany, updateEmail, checkSubscriptionStatus, cancelSubscription, getUserSubscriptions } from '../../utils/api';
import { refresh } from '../../services/auth.service';
import FadeIn from '../../utils/fadein';
import Spinner from '../../components/layout/Spinner';
import { FaTimes } from 'react-icons/fa';

const Subscription = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [status, setStatus] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [subscriptions, setSubsriptions] = useState([]);

  async function loadStatus(){
    let res = await checkSubscriptionStatus();
    let res2 = await getUserSubscriptions();

    if (res.success){
      setStatus(res.data);
      setLoaded(true);
    }

    if (res2.success){
      setSubsriptions(res2.data);
    }
  }

  useEffect(() => {
    async function loadStatus(){
      let res = await checkSubscriptionStatus();
      let res2 = await getUserSubscriptions();

      if (res.success){
        setStatus(res.data);
        console.log('data', res.data);
        setLoaded(true);
      }

      if (res2.success){
        setSubsriptions(res2.data);
      }
    }
    
    loadStatus();
  }, []);

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  async function handleConfirmCancel(){
    setCancelling(true);

    let res= await cancelSubscription();

    if (res.success){
      setCancelling(false);
      setShowConfirm(false);
      loadStatus();
    }
  }

  return (
    <div className="subscription">


      <div className=""><Link className='py-3 px-4 inline-flex items-center gap-x-2 text-sm font-bold rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700' to="/account/home">Back</Link></div>
      <div className="account__header">Subscriptions</div>

      {loaded == false && (
        <div>
          <Spinner />
        </div>
      )}

      {loaded == true && subscriptions.length > 0 && (
        <div className='subscription__status subscription__has-sub'>
            <h3>Subscription Status</h3>

            <p>
              You currently have an active <span className='bg-clip-text bg-gradient-to-tl from-blue-600 to-violet-600 text-transparent font-bold'>
                {subscriptions[0].name}
                </span> account.
            </p>

            <p>
              Need to cancel your subscription?
            </p>

            <p>
              <span className='link' onClick={() => setShowConfirm(true)}>Cancel Subscription</span>
            </p>
        </div>
      )}

      {loaded == true && status == false && (
        <div className='subscription__status subscription__no-sub'>
          <h3>Subscription Status</h3>

          <p>
            You're on the <strong>FREE</strong> plan.
          </p>

          <p>
            <Link className='link' to='/subscription'>Upgrade to <span className='bg-clip-text bg-gradient-to-tl from-blue-600 to-violet-600 text-transparent font-bold'>PRO</span></Link>
          </p>
        </div>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
        Profile updated successfully!
        </div>
      </FadeIn>
      )}

      {showConfirm && (
        <FadeIn delay={150} duration={300}>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowConfirm(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>
              Are you sure that you want to cancel your subscription?
            </h2>

            <p className='mt-10'>
              By cancelling your subscription, you will lose access to all premium features.
            </p>

            <p className='text-sm mt-20'>
              Your current subscription will remain active until the end of the billing cycle.
            </p>

            <p className='mt-30'>
              {cancelling == false && (
              <button className='btn btn--primary' onClick={()=> handleConfirmCancel()}>Confirm Cancellation</button>
              )}
              
              {cancelling == true && (
                <Spinner />
              )}
            </p>
          </div>
      </FadeIn>
      )}
    </div>
  )
}

  export default Subscription;